import loadable from '@loadable/component';
import React, { FunctionComponent } from 'react';

import styled, { keyframes } from 'styled-components';
import { InstaStories } from '../../../common/components/loaders/MenuLoader';
import { MenuItem } from '../MenuUtils';
import { DESKTOP_MENU_PANEL_WIDTH, DisplayMode } from './MenuDesktopContent';

const MenuCategoryContent = loadable(() => import('../components/MenuCategoryContent'), { fallback: <InstaStories /> });

interface Props {
  item: MenuItem;
  currentMenuPath: MenuItem[];
  menuSelectedPath: MenuItem[];
  setMenuSelectedPath: (menuItems: MenuItem[]) => void;
  panelNumber: number;
  closeMenu: () => void;
  onClick: (index: number, label: string) => void;
}

export const MenuListPanel: FunctionComponent<Props> = ({ onClick, item, menuSelectedPath, setMenuSelectedPath, currentMenuPath, panelNumber, closeMenu }) => {
  MenuCategoryContent.preload();
  return (
    <Panel index={panelNumber} width={DESKTOP_MENU_PANEL_WIDTH}>
      <MenuCategoryContent
        item={item}
        menuSelectedPath={menuSelectedPath}
        setMenuSelectedPath={setMenuSelectedPath}
        currentMenuPath={currentMenuPath}
        displayMode={DisplayMode.list}
        closeMenu={closeMenu}
        onClick={(label: string) => onClick(panelNumber, label)}
      />
    </Panel>
  );
};

export default MenuListPanel;

interface StyledPanelProps {
  index: number;
  width: number;
}

const Panel = styled.div<StyledPanelProps>`
  width: ${props => props.width}px;
  border-left: 1px solid #eee;
  padding: 10px;
  z-index: 99;
  position: fixed;
  top: 0;
  bottom: 0;
  left: ${props => props.index * props.width}px;
  background-color: white;
  animation: ${props => slideIn(props.index, props.width)} 0.5s;
  z-index: ${props => 11500 - props.index * 10};
  overflow-y: auto;

  img {
    width: ${props => props.width - 20}px;
    height: 220px;
  }
`;

const slideIn = (index: number, width: number) => keyframes`
    from {
        left: ${(index - 1) * width}px;
    }

    to {
        left: ${index * width}px;
    }
`;
